// ##### Komarov 2025-07-22
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-02-21 Komarov
import { changeLang, getCurrency } from '../../../../../Redux/actions';
// ##### 25-05-21 Komarov
import HeaderWrapperMain from './HeaderWrapperMain';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../../server/helpers/uniLog';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../../../hooks/usePerformanceMeasure';

// ##### Komarov 2025-07-22
const Header = () => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  const dispatch = useDispatch();
  const lang = useSelector(state => state.language);
  const currencies = useSelector(state => state.currency.currencies);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('Header', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for Header (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });

  // Думал, что язык работает и без этого запроса
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(changeLang(lang));
    // ##### 23-04-12 Komarov
  }, [lang, dispatch]);
  // Запрашиваем валюту из Смарта для сайта
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 24-07-25 Komarov
    currencies.length > 0 ||
      // ##### 25-04-30 Komarov
      uniLog(
        'axios:src/Components/Pages/PageComponents/ResponsiveHeader/Header.js:getCurrency()'
      );
    currencies.length > 0 || dispatch(getCurrency());
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  return <HeaderWrapperMain />;
};

export default Header;
